'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _compose = require('../lib/compose');

var _compose2 = _interopRequireDefault(_compose);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _paginationLink = require('../pagination-link');

var _paginationLink2 = _interopRequireDefault(_paginationLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      classNames = _ref.classNames,
      props = _objectWithoutProperties(_ref, ['children', 'classNames']);

  var propsWhitelist = ['children', 'styles', 'accessibility', 'adaptiveHeight', 'afterChange', 'arrows', 'autoplay', 'autoplaySpeed', 'beforeChange', 'centerMode', 'dots', 'dotsClass', 'draggable', 'easing', 'fade', 'focusOnSelect', 'infinite', 'initialSlide', 'lazyLoad', 'nextArrow', 'pauseOnHover', 'prevArrow', 'responsive', 'rtl', 'slickGoTo', 'slide', 'slidesToScroll', 'slidesToShow', 'speed', 'swipe', 'swipeToSlide', 'touchMove', 'touchThreshold', 'useCSS', 'variableWidth', 'vertical'];

  var allowedProps = (0, _pick2.default)(props, propsWhitelist);

  return _react2.default.createElement(
    'div',
    { className: 'c11n-carousel ' + classNames.root },
    _react2.default.createElement(
      _reactSlick2.default,
      _extends({
        prevArrow: _react2.default.createElement(_paginationLink2.default, { direction: 'prev' }),
        nextArrow: _react2.default.createElement(_paginationLink2.default, { direction: 'next' })
      }, allowedProps),
      children
    )
  );
};

Carousel.propTypes = {
  /**
   * The content of the Carousel
   */
  children: _propTypes2.default.any.isRequired,

  /**
   * Custom styles be applied { carousel }
   */
  styles: _propTypes2.default.object,

  /**
   * Slick slider settings
   */
  accessibility: _propTypes2.default.bool,
  adaptiveHeight: _propTypes2.default.bool,
  afterChange: _propTypes2.default.func,
  arrows: _propTypes2.default.bool,
  autoplay: _propTypes2.default.bool,
  autoplaySpeed: _propTypes2.default.number,
  beforeChange: _propTypes2.default.func,
  centerMode: _propTypes2.default.bool,
  dots: _propTypes2.default.bool,
  dotsClass: _propTypes2.default.string,
  draggable: _propTypes2.default.bool,
  easing: _propTypes2.default.string,
  fade: _propTypes2.default.bool,
  focusOnSelect: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  initialSlide: _propTypes2.default.number,
  lazyLoad: _propTypes2.default.bool,
  nextArrow: _propTypes2.default.element,
  pauseOnHover: _propTypes2.default.bool,
  prevArrow: _propTypes2.default.element,
  responsive: _propTypes2.default.array,
  rtl: _propTypes2.default.bool,
  slickGoTo: _propTypes2.default.func,
  slide: _propTypes2.default.string,
  slidesToScroll: _propTypes2.default.number,
  slidesToShow: _propTypes2.default.number,
  speed: _propTypes2.default.number,
  swipe: _propTypes2.default.bool,
  swipeToSlide: _propTypes2.default.bool,
  touchMove: _propTypes2.default.bool,
  touchThreshold: _propTypes2.default.number,
  useCSS: _propTypes2.default.bool,
  variableWidth: _propTypes2.default.bool,
  vertical: _propTypes2.default.bool
};

Carousel.defaultProps = {
  arrows: true,
  dots: false,
  autoplay: false,
  styles: {}
};

exports.default = (0, _compose2.default)((0, _withStyles2.default)(_styles2.default))(Carousel);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/carousel/index.js
// module id = 831
// module chunks = 0